export default "__VITE_ASSET__CHzhkVd6__";